import classNames from "classnames"
import React from "react"

import { Color } from "../../../../constants/V2/color"
import { getTextColorClass } from "../../../../utils/V2/color"
import ChevronIcon from "../Icons/ChevronIcon"

type Props = {
  onClick?: () => void
  direction: "left" | "right"
  id?: string
  className?: string
  color?: Color
  disabled?: boolean
}

const CarouselNavButton = ({
  onClick,
  direction,
  id,
  className,
  color = Color.White,
  disabled = false,
}: Props) => {
  return (
    <button
      id={id}
      disabled={disabled}
      onClick={onClick}
      className={classNames(
        "rounded-full border-[1px] border-white/10 bg-white/5 p-10 backdrop-blur-md",
        className,
        {
          "pointer-events-none opacity-50": disabled,
        }
      )}
    >
      <ChevronIcon
        className={classNames(
          getTextColorClass(color),
          direction === "right" ? "-rotate-90" : "rotate-90"
        )}
      />
    </button>
  )
}

export default CarouselNavButton
